/* eslint-disable */
import { useContext, useEffect, useState } from "react";
import { useStores } from "../use.store";
import React from "react";
import { observer } from "mobx-react-lite";
import { s3Url } from "../utils/constants";
import SearchEmptyStateComponent from "../components/SearchEmptyStateComponent";
import MarqueeCardItemComponent from "./MarqueeCardItemComponent";
import ACA from "@adactive/adsum-utils/services/ClientAPI";
import { SetSelectedPoiFromDirectory } from "../store/app/appActions";
import { useDispatch } from "react-redux";
import "./SearchView.css";
import closeIcon from "../assets/images/close.svg";
import locationIcon from "../assets/images/location.svg";
import { logAnalyticsEvent } from "../services/firebaseAnalytics";

const SearchView = observer(() => {
  const { generalStore } = useStores();
  const dispatch = useDispatch();
  const [query, setQuery] = useState("");
  const [poiList, setPoiList] = useState([]);
  const [searchHistory, setSearchHistroy] = useState([]);

  useEffect(() => {
    initData();
  }, []);

  let timeout;

  const handleInputChange = (event) => {
    clearTimeout(timeout); // Clear previous timeout
    const value = event.target.value;
    setQuery(value);
    timeout = setTimeout(() => {
      filterData(value);
    }, 300);
  };

  const initData = () => {
    let data = generalStore.pois.reduce((r, e) => {
      // get first letter of name of current element
      let group = e.name[0];
      // if there is no property in accumulator with this letter create it
      if (!r[group]) r[group] = { group, children: [e] };
      // if there is push current element to children array for that letter
      else r[group].children.push(e);
      // return accumulator
      return r;
    }, {});
    setPoiList(Object.values(data));
    if (generalStore.searchAction == "from") {
      setSearchHistroy(generalStore.historyFrom);
    } else {
      setSearchHistroy(generalStore.historyTo);
    }
  };

  const listCategory = ["All", "Medical Purposes", "Retails", "Retail-related"];
  const [open, setOpen] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedFloor, setSelectedFloor] = useState([]);
  const [selectedLevel, setSelectedLevel] = useState([]);
  function onDismiss() {
    setOpen(false);
  }

  const filterData = (searchQuery) => {
    console.log(searchQuery, "search query");

    const keywords = searchQuery.toLowerCase().split(" ");
    const filteredItems = generalStore.pois.filter((item) => {
      let parsedDescription;
      try {
        parsedDescription = JSON.parse(item.description);
      } catch (error) {
        parsedDescription = {};
      }

      const searchableFields = [
        item && item.name ? item.name.toLowerCase() : "",
        parsedDescription && typeof parsedDescription.location === "string"
          ? parsedDescription.location.toLowerCase()
          : "",
        parsedDescription && typeof parsedDescription.description === "string"
          ? parsedDescription.description.toLowerCase()
          : "",
      ];
      return keywords.every((keyword) =>
        searchableFields.some((field) => field.includes(keyword))
      );
    });
    let data = filteredItems.reduce((r, e) => {
      // get first letter of name of current element
      let group = e.name[0];
      // if there is no property in accumulator with this letter create it
      if (!r[group]) r[group] = { group, children: [e] };
      // if there is push current element to children array for that letter
      else r[group].children.push(e);
      // return accumulator
      return r;
    }, {});
    setPoiList(Object.values(data));
    setIsApplyFilter(true);
    setOpen(false);
  };

  const resetFilter = () => {
    // reset filter parameter
    setIsApplyFilter(false);
    setSelectedCategories([]);
    setSelectedFloor([]);
    setSelectedLevel([]);
    setQuery("");
    setIsShowLevel(false);
    // reset list data
    let data = generalStore.pois.reduce((r, e) => {
      // get first letter of name of current element
      let group = e.name[0];
      // if there is no property in accumulator with this letter create it
      if (!r[group]) r[group] = { group, children: [e] };
      // if there is push current element to children array for that letter
      else r[group].children.push(e);
      // return accumulator
      return r;
    }, {});
    setPoiList(Object.values(data));
  };

  // Filter
  const [isShowLevel, setIsShowLevel] = useState(false);
  const [isApplyFilter, setIsApplyFilter] = useState(false);

  const changeSelectedLevel = (floor) => {
    if (selectedLevel.includes(floor)) {
      setSelectedLevel(selectedLevel.filter((cat) => cat !== floor));
    } else {
      setSelectedLevel([floor]);
    }
  };

  const isShowFilterField = false;
  const toggleCategory = (category) => {
    if (selectedCategories.includes(category)) {
      setSelectedCategories(
        selectedCategories.filter((cat) => cat !== category)
      );
    } else {
      setSelectedCategories([...selectedCategories, category]);
    }
  };

  const changeSelectedFloor = (floor) => {
    if (selectedFloor.includes(floor.name)) {
      setSelectedFloor(selectedFloor.filter((cat) => cat !== floor.name));
    } else {
      if (["Paragon", "The Heeren", "Lucky Plaza"].includes(floor.name)) {
        // reset level when floor include in condtion
        setSelectedLevel([]);
        setIsShowLevel(false);
      } else {
        setIsShowLevel(true);
      }
      setSelectedFloor([floor.name]);
    }
  };

  const changeSelectedFilter = (filter, allData) => {
    if (filter === "All") {
      setSelectedFilter(selectedFilter.includes("All") ? [] : allData);
    } else {
      const newFilter = selectedFilter.includes(filter)
        ? selectedFilter.filter((cat) => cat !== filter)
        : [filter];

      setSelectedFilter(newFilter.filter((cat) => cat !== "All"));
    }
  };
  // End Filter

  const mappingFloorName = (floorName) => {
    if (floorName === "B1") return "Basement 1";

    const match = floorName.match(/^L(\d+)$/);
    if (match) {
      return `Level ${match[1]}`;
    }

    return floorName;
  };

  const handleSetSelectedPoiFromDirectory = (poi) => {
    const object = generalStore.awm.objectManager.getSpace(poi.shape_id);
    if (!object) {
      console.error("No object found for shape_id:", poi.shape_id);
      console.log("Full poi object:", poi);
      return; // or handle the error appropriately
    }
    const pois = ACA.getPoisFromPlace(object.placeId);
    const place = ACA.getPlace(object.placeId);
    if (pois && pois.length > 0) {
      if (Array.from(pois[0].categories.length > 0)) {
        const categoryId = pois[0].categories[0].id;
        const checkCategory = ACA.getCategoriesBy({ id: [categoryId] });
        const isAmenities =
          !checkCategory && checkCategory[0].name === "Amenities";
        if (!isAmenities) {
          const poiPlaces = pois.map((poi) => {
            const places = Array.from(poi.places.values).map((place) =>
              ACA.getPlace(place.value)
            );
            return {
              ...poi,
              places,
              placeId: object.placeId,
              locations: [place],
            };
          });
          logAnalyticsEvent("destination", {
            poi: `${poiPlaces[0].name}`,
          });
          dispatch(SetSelectedPoiFromDirectory(poiPlaces[0]));
        }
      }
    }
  };

  return (
    <div className="w-full h-full flex flex-col items-center justify-center bg-whiteBg absolute z-[999999] md:max-w-[640px] md:max-h-[680px] md:mx-auto md:my-auto md:top-[130px] left-1/2 -translate-x-1/2 md:rounded-xl py-2">
      <div className="flex flex-row w-full items-center justify-center gap-2 px-4 pt-6 pb-6 overflow-hidden">
        <div className="flex-grow relative flex items-center w-full h-12 rounded-lg focus-within:shadow-lg bg-whiteBg">
          <input
            className="peer h-full w-full outline-none text-sm text-gray-700 px-3"
            type="text"
            id="search"
            value={query}
            onChange={handleInputChange}
            placeholder={
              generalStore.searchAction == "from"
                ? "Your Location"
                : "Where to?"
            }
          />
          <div className="grid place-items-center h-full w-12 text-gray-300">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </div>
        </div>
        <img
          onClick={() => {
            generalStore.searchAction = "";
          }}
          src={closeIcon}
          className="h-8 w-8"
        />
      </div>
      <div
        className={`h-full w-full md:max-w-[640px] md:max-h-[680px] overflow-auto ${
          poiList.length > 0 ? "" : "scrollbar-hide"
        }`}
      >
        {searchHistory.length > 0 && (
          <div className="w-full grid grid-cols-1 gap-4 p-4 content-start ">
            <span className="text-sm font-bold text-gray-400">
              Search History
            </span>
            {searchHistory.map((poi, index) => {
              return (
                <div
                  className="flex flex-row gap-2"
                  key={index + "search"}
                  onClick={() => {
                    if (generalStore.searchAction == "from") {
                      generalStore.from = poi;
                      generalStore.historyFrom.unshift(poi);
                      if (generalStore.historyFrom.length > 3) {
                        generalStore.historyFrom =
                          generalStore.historyFrom.pop();
                      }
                    } else {
                      generalStore.to = poi;
                      generalStore.historyTo.unshift(poi);
                      if (generalStore.historyTo.length > 3) {
                        generalStore.historyTo = generalStore.historyTo.pop();
                      }
                    }
                    generalStore.fromSearchAction = true;
                    generalStore.searchAction = "";
                  }}
                >
                  <img src={require("../assets/images/clock.png")} />
                  <span className="font-medium text-sm text-gray-600 line-clamp-1">
                    {poi.name}
                  </span>
                </div>
              );
            })}
          </div>
        )}
        <div className="flex w-full text-left items-start">
          {poiList.length > 0 ? (
            (selectedCategories.length > 0 || selectedFloor.length > 0) &&
            isApplyFilter && (
              <div className="flex flex-wrap items-center px-4">
                <div>
                  <span className="pr-1 font-medium text-sm">Filters:</span>
                </div>
                <div>
                  {selectedCategories.map((categoryId, index) => {
                    const category = generalStore.allCategories.find(
                      (cat) => cat.id === categoryId
                    );
                    return (
                      <span
                        key={categoryId}
                        className="font-medium text-sm text-primary mr-1"
                      >
                        {category ? category.name : categoryId}
                        {index < selectedCategories.length - 1 ||
                        selectedFloor.length > 0
                          ? ","
                          : ""}
                      </span>
                    );
                  })}
                </div>
                <div>
                  {selectedFloor.map((categoryId, index) => {
                    const category = generalStore.allCategories.find(
                      (cat) => cat.id === categoryId
                    );
                    return (
                      <span
                        key={categoryId}
                        className="font-medium text-sm text-primary mr-1"
                      >
                        {category ? category.name : categoryId}
                        {index < selectedFloor.length - 1 ? "," : ""}
                      </span>
                    );
                  })}
                </div>

                {selectedLevel.length > 0 && (
                  <div>
                    {(selectedCategories.length > 0 ||
                      selectedFloor.length > 0) && (
                      <span className="font-medium text-sm text-primary mr-1">
                        at
                      </span>
                    )}
                    {selectedLevel.map((floorId, index) => {
                      const floor = generalStore.floors.find(
                        (floor) => floor.id === floorId
                      );
                      return (
                        <span
                          key={floorId}
                          className="font-medium text-sm text-primary mr-1"
                        >
                          {floor ? mappingFloorName(floor.name) : floorId}
                          {index < selectedLevel.length - 1 ? "," : ""}
                        </span>
                      );
                    })}
                  </div>
                )}
              </div>
            )
          ) : (
            <SearchEmptyStateComponent
              selectedCategories={selectedCategories}
              selectedFloor={selectedFloor}
            />
          )}
        </div>
        {
          <div className="w-full grid grid-cols-1 gap-4 p-4 content-start ">
            {poiList.map((e) => {
              return (
                <div
                  key={e.group + "group"}
                  className="w-full h-auto flex flex-col gap-2"
                >
                  <span className="text-sm font-medium text-gray-400">
                    {e.group}
                  </span>
                  <div className="flex flex-col w-full gap-2">
                    {e.children.map((poi) => {
                      return (
                        <div
                          className="bg-white rounded-lg flex flex-row gap-2"
                          key={poi.id}
                          onClick={() => {
                            if (generalStore.searchAction == "from") {
                              generalStore.from = poi;
                              if (generalStore.historyFrom[0] != poi) {
                                generalStore.historyFrom.unshift(poi);
                                if (generalStore.historyFrom.length > 3) {
                                  generalStore.historyFrom.pop();
                                }
                              }
                            } else {
                              generalStore.to = poi;
                              if (generalStore.historyTo[0] != poi) {
                                generalStore.historyTo.unshift(poi);
                                if (generalStore.historyTo.length > 3) {
                                  generalStore.historyTo.pop();
                                }
                              }
                            }
                            handleSetSelectedPoiFromDirectory(poi);
                            generalStore.fromSearchAction = true;
                            generalStore.searchAction = "";
                          }}
                        >
                          <img
                            src={(() => {
                              try {
                                const description = JSON.parse(poi.description);
                                return description.logo
                                  ? `${s3Url}/poi/${description.logo}`
                                  : require("../assets/images/default.png");
                              } catch (error) {
                                return require("../assets/images/default.png");
                              }
                            })()}
                            className="object-contain w-24 h-24 rounded-s-lg"
                          />
                          <div className="flex-grow flex flex-col items-start justify-center gap-4">
                            <h2 className="text-sm font-medium line-clamp-1">
                              <MarqueeCardItemComponent content={poi.name} />
                            </h2>
                            <div className="flex flex-row gap-2 items-center justify-center">
                              <img
                                src={locationIcon}
                                className="object-contain w-3 h-3"
                              />
                              <div className="flex-grow">
                                <span className="text-primary font-light text-sm line-clamp-1">
                                  {(() => {
                                    try {
                                      const description = JSON.parse(
                                        poi.description
                                      );

                                      return description.location
                                        ? description.location
                                        : "";
                                    } catch (error) {
                                      return "";
                                    }
                                  })()}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        }
      </div>
      {/* <FilterModal
        allCategories={generalStore.allCategories}
        changeSelectedFilter={changeSelectedFilter}
        open={open}
        setOpen={() => {
          setOpen(false);
          if (!isApplyFilter) {
            resetFilter();
          }
        }}
        onDismiss={onDismiss}
        changeSelectedFloor={changeSelectedFloor}
        filterData={filterData}
        floors={generalStore.floors}
        isShowFilterField={isShowFilterField}
        listCategory={listCategory}
        resetFilter={() => resetFilter()}
        selectedCategories={selectedCategories}
        selectedFilter={selectedFilter}
        selectedFloor={selectedFloor}
        toggleCategory={toggleCategory}
        query={query}
        isShowLevel={isShowLevel}
        filtersData={Object.values(generalStore.tags)}
        changeSelectedLevel={changeSelectedLevel}
        selectedLevel={selectedLevel}
      /> */}
    </div>
  );
});

export default SearchView;
